import "../styles/components/Footer.css";

export function Footer() {

  return (
    <footer>
      <strong>
        Made with 💚 by
        <a href="https://github.com/gustavopolonio" target="_blank"> Gustavo Polonio</a> 
      </strong>
    </footer>
  )
}